import { render, staticRenderFns } from "./FormInputPayment.vue?vue&type=template&id=56bdff6a&"
import script from "./FormInputPayment.vue?vue&type=script&lang=js&"
export * from "./FormInputPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bdff6a')) {
      api.createRecord('56bdff6a', component.options)
    } else {
      api.reload('56bdff6a', component.options)
    }
    module.hot.accept("./FormInputPayment.vue?vue&type=template&id=56bdff6a&", function () {
      api.rerender('56bdff6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputPayment.vue"
export default component.exports